import {
  always,
  applySpec,
  compose,
  find,
  ifElse,
  includes,
  isEmpty,
  map,
  of,
  prop,
  propEq,
  propOr
} from 'ramda';
import { ControlledSelect } from '@@viewCommonComponents/controlled';
import { isRequiredSelect } from '@@viewHelpers/validations';
import { useProcess } from '@fasstech/oip-starter-utils/app';
import { groups } from './formatExtraData.js';

const SouscriptionCustomerExtraForm = ({ project, form }) => {
  const { context } = useProcess();
  const { defaultGroupCode, groupCodes } = applySpec({
    defaultGroupCode: propOr('', 'defaultGroupCode'),
    groupCodes: propOr([], 'groupCodes')
  })(project);

  const labelRouteDisplay = (code) => {
    return compose(prop('labelRouteDisplay'), find(propEq('code', code)))(groups);
  };

  const groupCodesToOptions = (code) => {
    return {
      value: code,
      label: labelRouteDisplay(code)
    };
  };

  const options = ifElse(
    isEmpty,
    always(of(groupCodesToOptions(defaultGroupCode))),
    map(groupCodesToOptions)
  )(groupCodes);

  if (includes('BROKER', context.creatorUserRoles)) {
    return null;
  }
  return (
    <ControlledSelect
      name="defaultGroupCode"
      label={'Groupe (référence interne Pavillon Prévoyance)'}
      form={form}
      options={options}
      rules={isRequiredSelect(options)}
      data-testid="CUSTOMER_GROUP"
    />
  );
};

export default SouscriptionCustomerExtraForm;
